// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3H0te","footer":"ModalError_footer__R3Bq0"};